<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" :top="'5vh'" :fullscreen="isExpand" :show-close="false" :before-close="handleClose" width="1200px">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>查看</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="订阅信息" name="subscribe">
          <el-descriptions v-if="detailInfo.openBizOppSubFlag" :column="1">
            <el-descriptions-item label="订阅地区">
              <template v-if="detailInfo.subAreaType === 1">不限地区</template>
              <template v-if="detailInfo.subAreaType === 2">
                <div class="long-text">{{ (detailInfo.areaList || []).map(item => item.value).join('、') || '--' }}</div>
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="订阅分类">
              {{ (detailInfo.categoryList || []).map(item => item.value).join('、') || '--' }}
            </el-descriptions-item>
            <el-descriptions-item label="订阅品牌">
              {{ (detailInfo.brandList || []).map(item => item.value).join('、') || '--' }}
            </el-descriptions-item>
            <el-descriptions-item label="关键字">
              {{ (detailInfo.keywordList || []).map(item => item.value).join('、') || '--' }}
            </el-descriptions-item>
          </el-descriptions>
          <el-empty v-else description="无订阅信息"></el-empty>
        </el-tab-pane>
        <el-tab-pane label="订阅动态" name="subscribeDynamic">
          <TableWithPagination class="special" :columnList="subscribeDynamicColumnList" :tableData="subscribeDynamicLists" :sortInfo.sync="sortInfo" tableBorder="default" :pagination.sync="subscribeDynamicPagination" @size-change="getSubscribeDynamic" @current-change="getSubscribeDynamic" @sort-change="getSubscribeDynamic" :highHoverRow="false" :highlightRow="false" />
        </el-tab-pane>
        <el-tab-pane label="历史推送记录" name="pushRecord">
          <PushTenantList :tenantId="currentDetail.tenantId" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as dayjs from 'dayjs';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getBizOppSubTenantDetail, getBizOppSubTenantDynamicPageList } from '@/api/niche.js';
import PushTenantList from './pushTenantList.vue';
export default {
  name: 'SubscribeDetailDialog',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
    PushTenantList,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentDetail: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'), // eslint-disable-line
      collapseSvg: require('@/assets/ic_collapse.svg'), // eslint-disable-line
      activeName: 'subscribe',
      detailInfo: {},
      subscribeDynamicLists: [],
      subscribeDynamicPagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    subscribeDynamicColumnList () {
      return [
        {
          tooltip: true,
          label: '时间',
          minWidth: '',
          width: '140px',
          key: 'operateTime',
          prop: 'operateTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '操作人',
          minWidth: '',
          width: '140px',
          key: 'createUserName',
          prop: 'createUserName',
        },
        {
          tooltip: true,
          label: '事项类型',
          minWidth: '',
          width: '140px',
          key: 'actionDesc',
          prop: 'actionDesc',
        },
        {
          tooltip: true,
          label: '事项描述',
          minWidth: '',
          width: '',
          key: 'content',
          prop: 'content',
        },
      ];
    },
  },
  methods: {
    formatTime (v) {
      let ret = '';
      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }
      return ret;
    },
    handleClose () {
      this.$emit('update:dialogVisible', false);
    },
    getSubscribeDetail () {
      getBizOppSubTenantDetail({ tenantId: this.currentDetail.tenantId }).then(({ body }) => {
        const parentKeyLists = (body?.categoryList || []).map(item => item.parentKey);
        const categoryList = (body?.categoryList || []).filter(item => !parentKeyLists.includes(item.key));
        this.detailInfo = body || {};
        this.detailInfo.categoryList = categoryList;
      });
    },
    getSubscribeDynamic () {
      const params = {
        businessId: this.currentDetail.id,
        module: 'BIZ_OPP_SUB',
        pageSize: this.subscribeDynamicPagination.pageSize,
        pageNum: this.subscribeDynamicPagination.currentPage,
      };

      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }

      getBizOppSubTenantDynamicPageList(params).then(({ body }) => {
        this.subscribeDynamicLists = body?.list || [];
        this.subscribeDynamicPagination.total = Number(body?.total || 0);
      });
    },
  },
  mounted () {
    if (this.currentDetail.tenantId) {
      this.getSubscribeDetail();
    }
    if (this.currentDetail.id) {
      this.getSubscribeDynamic();
    }
  },
};
</script>

<style lang="scss" scoped>
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
  .content {
    padding: 0 20px;
  }
}
</style>
